import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { PlaylistAssignmentsProgressContainer, getPlaylistAssignmentsUrl } from '..';
import UIProgress from 'UIComponents/progress/UIProgress';
import I18n from 'I18n';
import UIBox from 'UIComponents/layout/UIBox';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled, { theme } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProgressAssigneesCount = styled(FormattedMessage).withConfig({
  displayName: "PlaylistAssignmentsPortalProgress__ProgressAssigneesCount",
  componentId: "sc-1ur42ft-0"
})(["color:", ";font-weight:400;"], theme.colors.EERIE);
const PlaylistAssignmentsPortalProgress = ({
  portal: {
    portal: {
      id: portalId,
      companyName: portalName
    },
    progressPercentage,
    playlistId,
    assignees
  },
  url = getPlaylistAssignmentsUrl(playlistId, portalId),
  showAssigneesCount
}) => {
  return /*#__PURE__*/_jsxs(PlaylistAssignmentsProgressContainer, {
    children: [/*#__PURE__*/_jsx(UIBox, {
      children: url ? /*#__PURE__*/_jsx(UIRouterLink, {
        to: url,
        children: portalName
      }) : portalName
    }), showAssigneesCount && /*#__PURE__*/_jsx(ProgressAssigneesCount, {
      message: "learningCenter.playlistAssignments.assigneesCount",
      options: {
        count: assignees.length
      }
    }), /*#__PURE__*/_jsx(UIProgress, {
      "aria-label": I18n.text('learningCenter.playlistAssignments.teamProgress', {
        progressPercentage: I18n.formatPercentage(progressPercentage)
      }),
      use: "success",
      value: progressPercentage
    })]
  });
};
export default PlaylistAssignmentsPortalProgress;